
































































import { Component, Mixins } from "vue-property-decorator";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import { AbonentInfoModule } from "@/store/abonentinfo.module";
import { translate } from "@/utils";
import { Abonent } from "~/abonent.type";
import AbonentItem from "@/components/ui/AbonentItem.vue";
import ExpansionPanel from "@/components/ui/ExpansionPanel.vue";

@Component({
  components: { AbonentItem, ExpansionPanel },
})
export default class AbonentView extends Mixins(ContractIdValidatorMixin) {
  get infoLoading(): boolean {
    return AbonentInfoModule.abonentIsLoading;
  }

  get getInfo(): Abonent {
    return translate(AbonentInfoModule.abonentInfo);
  }

  detailKeys = [
    "contract_bin",
    "contract_bank_name",
    "contract_bank_number",
    "is_resident",
    "contract_kbe",
    "contract_knp",
    "contractor_country_name",
    "district_name",
    "contractor_real_address",
    "receiver_name",
    "contract_address",
    "contract_post_index",
  ];

  get details() {
    const details: any[] = [];

    for (const key of this.detailKeys) {
      if (key === "is_resident") {
        details.push({
          label: key,
          text: this.getInfo.is_resident
            ? this.$t("abonentInfo.yes")
            : this.$t("abonentInfo.no"),
        });
      } else {
        details.push({
          label: key,
          text: this.getInfo[key as keyof Abonent],
        });
      }
    }
    return details;
  }

  async mounted() {
    await this.validateContractId();
    AbonentInfoModule.setAbonentInfoIsLoading(true);
    AbonentInfoModule.getAbonentInfo(this.$route.params.id);
  }
}
